<div class="data-picker-container">
  <button
    class="itemData"
    style="z-index: 1000"
    [disabled]="diabledButtonWeek||disabledComponent"
    (click)="beforeClick()"
    mat-mini-fab color="primary">
    <mat-icon>navigate_before</mat-icon>
  </button>
  <div>
    @if (rangeData) {
      @if (rangeDateIsValid$|async) {
        <mat-card
          [ngClass]="{'disabled-card':disabledComponent}"
          (click)="openPicker(picker)"
          class="spacerw5"
          style="cursor:pointer;font-weight: bold;border-radius: 50px;min-width: 80px;text-align: center"
          >
          <mat-card-content class="color-contrast-theme">
            @switch (typeDate) {
              @case ('deltaYear') {
                {{ (fromDate$|async)!|hunaDate:'custom':'yyyy'|async }}
              }
              @case ('deltaMonth') {
                {{ (fromDate$|async)!|hunaDate:'custom':'MMMM'|async }}
                ,  {{ (fromDate$|async)!|hunaDate:'custom':'yyyy'|async }}
              }
              @default {
                {{ (fromDate$|async)!|hunaDate:'mediumDate':'noYear'|async }}
                - {{ (toDate$|async)!|hunaDate:'mediumDate':'noYear'|async }}
                ,  {{ (toDate$|async)!|hunaDate:'custom':'yyyy'|async }}
              }
            }
          </mat-card-content>
        </mat-card>
      }
      <div style="z-index: -10000 ;max-width: 0px;max-height: 0px;margin-left: -50px;margin-top: -50px;margin-bottom: 50px;opacity: 0">
        <mat-date-range-input
          style="z-index: -10000 ;width: 0px"
          [max]="allowFuture ? null : today"
          [formGroup]="formGroup"
          [rangePicker]="picker"
          >
          <input matStartDate formControlName="fromDate">
          <input matEndDate formControlName="toDate">
        </mat-date-range-input>
        <mat-datepicker-toggle
          style="z-index: -10000 ;width: 0px;"
          matSuffix [for]="picker">
        </mat-datepicker-toggle>
        <mat-date-range-picker
          (closed)="closePicker()"
          style="z-index: -10000 ;width: 0px"
          #picker
          >
        </mat-date-range-picker>
        <!--                <mat-date-range-picker-->
        <!--                        (closed)="closePicker()"-->
        <!--                        style="z-index: -10000 ;width: 0px"-->
        <!--                        #picker-->
        <!--                        appRangeDate [maxRange]="deltaDate"-->
        <!--                >-->
      <!--                </mat-date-range-picker>-->
    </div>
  } @else {
    <div style="z-index: -10000 ;max-width: 0px;max-height: 0px;margin-left: -50px;opacity: 0">
      <ng-container [formGroup]="formGroup">
        <input matInput formControlName="toDate" [matDatepicker]="picker" [max]="allowFuture ? null : today">
        <mat-datepicker-toggle
        matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker
        #picker (closed)="closePickerSingleDate()"></mat-datepicker>
      </ng-container>
    </div>
    <mat-card [ngClass]="{'disabled-card':disabledComponent}"
      (click)="openPicker(picker)"
      class="spacerw5" style="cursor:pointer;font-weight: bold;border-radius: 50px"
      >
      @if (rangeDateIsValid$|async) {
        <mat-card-content class="color-contrast-theme">
          {{ (fromDate$|async)!|hunaDate:'mediumDate':'noYear'|async }}
          ,  {{ (toDate$|async)!|hunaDate:'custom':'yyyy'|async }}
        </mat-card-content>
      }
    </mat-card>
  }
</div>
<button class="itemData"
  (click)="nextClick();"
  [disabled]="diabledButtonWeek||disabledComponent||(disableNextButton$|async)!"
  mat-mini-fab color="primary">
  <mat-icon>navigate_next</mat-icon>
</button>
</div>